'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FileIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.75 3.25V8.25C12.75 8.80228 13.1977 9.25 13.75 9.25H18.75M5.75 2.75H12.3358C12.601 2.75 12.8554 2.85536 13.0429 3.04289L18.9571 8.95711C19.1446 9.14464 19.25 9.399 19.25 9.66421V20.25C19.25 20.8023 18.8023 21.25 18.25 21.25H5.75C5.19771 21.25 4.75 20.8023 4.75 20.25V3.75C4.75 3.19772 5.19772 2.75 5.75 2.75Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
const VpFileIcon = forwardRef(FileIcon);

export { VpFileIcon as default };
